import { forwardRef } from 'react';
import turfDistance from '@turf/distance';
import { FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import { TrailDetailsBox } from './trail_details_box';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { setWindowExitGuard } from '../../../../utils/window_helpers';
import { getMapDistance } from '../../../../utils/at_map_helpers';
import { getFormattedTrailUrls } from '../../../../utils/trail_helpers';
import { humanized_time_span } from '../../../../utils/humanized_time_span';
import { MapStatsUtil } from '../../../../utils/map_stats_util';

const createReactClass = require('create-react-class');

// Keep this in sync with Trail::LENGTH_MIN
const MIN_TRAIL_LENGTH_METERS = 160.9344;

const BaseEditTrailBox = createReactClass({
  getInitialState() {
    return {
      currentState: '',
      isPendingTrail: this.props.trail.metadata.status == 'P'
    };
  },
  renderLocation(location) {
    const locations = [];
    if (location && location.country) locations.push(<li key="country">{location.country}</li>);
    if (location && location.region) locations.push(<li key="region">{location.region}</li>);
    if (location && location.city) locations.push(<li key="city">{location.city}</li>);
    return locations;
  },
  componentDidMount() {
    this.apiTrailId = null;
    this.subscriptions = [];
  },
  componentWillUnmount() {
    while (this.subscriptions.length) this.subscriptions.pop().unsubscribe();
  },
  handleViewPostError() {
    console.log('handleViewPostError');
  },
  handleViewPostComplete() {},
  handleItemPostSuccess() {},
  handleItemPostError() {
    console.log('handleItemPostError');
  },
  handleItemPostComplete(data) {
    if (--this.unsavedItems == 0) {
      setWindowExitGuard(false);
      // this.setState({currentState: ""});

      // Immediately apply edits (rather than waiting for hourly job run) in certain cases:
      if (!this.state.isPendingTrail && this.state.setToPending) {
        const url = '/api/alltrails/edits/apply';
        ServerCommunicationUtil.getApiEndpoint(
          url,
          {
            type: 'trail',
            target_object_id: this.props.trail.id,
            set_to_pending: this.state.setToPending
          },
          this.handleApplyPostSuccess,
          this.handleApplyPostError,
          this.handleApplyPostComplete
        );
      } else if ((this.state.isPendingTrail || this.props.adminUser) && this.apiTrailId) {
        const url = '/api/alltrails/edits/apply';
        ServerCommunicationUtil.getApiEndpoint(
          url,
          {
            type: 'trail',
            target_object_id: this.apiTrailId,
            set_to_active: this.state.setToActive
          },
          this.handleApplyPostSuccess,
          this.handleApplyPostError,
          this.handleApplyPostComplete
        );
      } else if (this.props.adminUser) {
        const { localizedUrl } = getFormattedTrailUrls(this.props.trail, this.props.context.languageRegionCode);
        window.location = localizedUrl;
        return false;
      }
    }
  },
  handleApplyPostComplete() {},
  handleFoundTrail(data) {
    if (data && data.trails[0].slug) {
      clearInterval(this.checkForTrailInterval);
      window.location = LanguageSupportUtil.wrapUrlSafe(`/trail/${data.trails[0].slug}`, this.props.context.languageRegionCode);
    }
  },
  handleFoundTrailError() {},
  handleFoundTrailComplete() {},
  checkForTrail(trailId) {
    const url = `/api/alltrails/trails/${trailId}?include_pending=true`;
    ServerCommunicationUtil.getApiEndpoint(url, {}, this.handleFoundTrail, this.handleFoundTrailError, this.handleFoundTrailComplete);
  },
  handleApplyPostSuccess(data) {
    // If this is a new trail we need to wait for async processing, check every 2.5 secs
    if (this.props.trail.id == null && this.apiTrailId != null) {
      this.checkForTrailInterval = setInterval(this.checkForTrail.bind(null, this.apiTrailId), 2500);
    } else {
      window.location = LanguageSupportUtil.wrapUrlSafe(`/trail/${data.trails[0].slug}`, this.props.context.languageRegionCode);
    }
  },
  handleApplyPostError() {
    console.log('handleApplyPostError');
  },
  handleGroupPostError() {
    console.log('handleGroupPostError');
  },
  handleGroupPostComplete() {},
  postEditItem(itemUrl, newEdit) {
    ServerCommunicationUtil.postApiEndpoint(itemUrl, newEdit, this.handleItemPostSuccess, this.handleItemPostError, this.handleItemPostComplete);
  },
  handleTrailView(successCallback) {
    if (!this.props.trail.id) {
      successCallback();
      return;
    }
    const viewUrl = '/api/alltrails/edits/contribute/views';
    ServerCommunicationUtil.postApiEndpoint(
      viewUrl,
      { type: 'trail', target_object_id: this.props.trail.id },
      successCallback,
      this.handleViewPostError,
      this.handleViewPostComplete
    );
  },
  saveEdits(newEdits) {
    this.newGroupUrl = '/api/alltrails/edits/groups';
    if (newEdits.length > 0) {
      this.unsavedItems = newEdits.length;
      setWindowExitGuard(true);
      this.setState({ currentState: 'saving' });
      const postItemsCallback = function (data) {
        const editGroupId = data.editGroups[0].id;
        this.apiTrailId = data.editGroups[0].targetObjectId;
        const itemUrl = `${this.newGroupUrl}/${editGroupId}/items`;
        for (let i = 0; i < newEdits.length; i++) {
          const { itemPostHandler, itemPostHandlerData } = newEdits[i];
          if (itemPostHandler) {
            itemPostHandler(itemUrl, newEdits[i], this.postEditItem, itemPostHandlerData);
          } else {
            this.postEditItem(itemUrl, newEdits[i]);
          }
        }
      }.bind(this);
      ServerCommunicationUtil.postApiEndpoint(
        this.newGroupUrl,
        {
          type: 'trail',
          target_object_id: this.props.trail.id,
          origin_object_id: !this.props.trail.id && this.props.trail.defaultMap ? this.props.trail.defaultMap.id : undefined
        },
        postItemsCallback,
        this.handleGroupPostError,
        this.handleGroupPostComplete
      );
    } else if (this.props.adminUser) {
      // No edits made, but return to trail page as would do if edits had been saved
      const { localizedUrl } = getFormattedTrailUrls(this.props.trail, this.props.context.languageRegionCode);
      window.location = localizedUrl;
    }
  },
  handleSaveClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.refs.detailsEdits.getNameValue().trim() == '') {
      alert(this.props.intl.formatMessage({ defaultMessage: 'Please enter a trail name.' }));
      return false;
    }

    if (this.props.trail.id) {
      if (isNaN(this.refs.detailsEdits.state.cityId)) {
        alert(this.props.intl.formatMessage({ defaultMessage: 'Please choose or enter a city.' }));
        return false;
      }
      if (this.refs.detailsEdits.state.cityId == -1) {
        const regionAndCountry = this.refs.detailsEdits.refs.regionAndCountry.getSelectedValues();
        const freeFormCity = this.refs.detailsEdits.refs.cityFreeForm.value;
        if (freeFormCity == '') {
          alert(this.props.intl.formatMessage({ defaultMessage: 'Please enter a city name.' }));
          return false;
        }
        if (regionAndCountry.countryId <= 0) {
          alert(this.props.intl.formatMessage({ defaultMessage: 'Please choose a country.' }));
          return false;
        }
      }
    }
    let vrouteInfo = this.props.routeInfo;
    if (!vrouteInfo) {
      vrouteInfo = {
        distance: getMapDistance(this.props.useMapAsRoute)
      };
    }
    if (!(vrouteInfo.distance > 0 || this.props.trail.defaultMap)) {
      alert(this.props.intl.formatMessage({ defaultMessage: 'Please draw the route of the trail.' }));
      return false;
    }

    if (!this.props.adminUser && vrouteInfo.distance < MIN_TRAIL_LENGTH_METERS) {
      const minimumLength = MapStatsUtil.metersToFormattedUserUnits(
        MIN_TRAIL_LENGTH_METERS,
        1,
        this.props.displayMetric,
        this.props.context.languageRegionCode
      );
      const currentLength = MapStatsUtil.metersToFormattedUserUnits(
        vrouteInfo.distance,
        1,
        this.props.displayMetric,
        this.props.context.languageRegionCode
      );
      alert(
        this.props.intl.formatMessage(
          {
            defaultMessage: 'The trail must be at least {minimumLength} long and is currently only {currentLength}.'
          },
          { minimumLength, currentLength }
        )
      );
      return false;
    }

    const selectedActivities = this.refs.detailsEdits.getSelectedActivities();
    if (!(selectedActivities.length > 0)) {
      alert(this.props.intl.formatMessage({ defaultMessage: 'Please select at least one activity for the trail.' }));
      return false;
    }

    if (!this.refs.detailsEdits.getDifficultyEdit()) {
      alert(this.props.intl.formatMessage({ defaultMessage: 'Please select a difficulty rating for the trail.' }));
      return false;
    }

    const pressedApprove = this.props.adminUser && e.target.id != 'savenoapproval-button';
    const pressedMakePending = this.props.adminUser && e.target.id == 'makepending-button';
    if (!pressedMakePending) {
      const routeType = this.refs.detailsEdits.getRouteTypeValue();
      if (!(!routeType || routeType == '')) {
        if (vrouteInfo.distance > 0) {
          if (vrouteInfo.endsCoincide && routeType == 'P') {
            if (
              !confirm(
                this.props.intl.formatMessage({
                  defaultMessage:
                    "The start & end of the route are at the same location even though the route type is set to Point-to-Point. Please fix the route or correct the route type before proceeding. If you're sure this is correct press OK."
                })
              )
            ) {
              return false;
            }
          } else if (!vrouteInfo.endsCoincide && routeType != 'P' && vrouteInfo.routeStartPt && vrouteInfo.routeEndPt) {
            const startToEnd = turfDistance(vrouteInfo.routeStartPt, vrouteInfo.routeEndPt) * 1000;
            if (startToEnd > 100) {
              alert(
                this.props.intl.formatMessage({
                  defaultMessage:
                    "The start & end of the trail aren't at the same location. Please finish drawing the route back to the starting point."
                })
              );
              return false;
            }
          }
        }
      } else {
        alert(this.props.intl.formatMessage({ defaultMessage: 'Please select a route type for the trail.' }));
        return false;
      }
    }

    const allTrailEdits = this.refs.detailsEdits.getAllTrailEdits();
    if (this.props.rapidRoute && this.state.isPendingTrail && pressedApprove) {
      this.setState({ setToActive: true });
      // If the admin pressed Approve, but did not change anything, generate at least one
      // edit item (even though it is not an actual change) so that trail is updated to approved in the next batch run.
      if (allTrailEdits.length == 0) {
        allTrailEdits.push(this.refs.detailsEdits.getNameEdit());
      }
    } else if (this.props.rapidRoute && !this.state.isPendingTrail && pressedMakePending) {
      this.setState({ setToPending: true });
      // If the admin pressed Make Pending, but did not change anything, generate at least one
      // edit item (even though it is not an actual change) so that trail is updated to Pending (as soon as posted).
      if (allTrailEdits.length == 0) {
        allTrailEdits.push(this.refs.detailsEdits.getNameEdit());
      }
    }

    // convert km to miles for length edit item creation on the server
    if (this.props.displayMetric) {
      for (let i = 0; i < allTrailEdits.length; i++) {
        if (allTrailEdits[i].type == 'length') {
          allTrailEdits[i].data.length *= 0.621371;
        }
      }
    }

    this.saveEdits(allTrailEdits);
    if (!this.props.adminUser && !this.state.isPendingTrail) {
      this.handleTrailView(this.props.nextTrailCallback);
    }
    return false;
  },

  handleRejectTrailClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!confirm('Reject this new trail?')) return false;
    const url = `/api/alltrails/trails/${this.props.trail.id}`;
    ServerCommunicationUtil.deleteApiEndpoint(url, {}, this.handleTrailDeleted, this.handleTrailDeletedError, this.handleTrailDeletedComplete);
    return false;
  },
  handleTrailDeleted(xhr, status) {
    // should take user to a blank contribute view to indicate that the trail was deleted
    window.location.reload();
  },
  handleTrailDeletedComplete(xhr, status) {},
  handleTrailDeletedError(xhr, status, error) {
    console.log(`Failure: ${error}`);
  },
  render() {
    const photoUrl = this.props.trail.id
      ? `/api/alltrails/trails/${this.props.trail.id}/profile_photo?api_key=${ServerCommunicationUtil.apiKey}&size=small_square`
      : '';
    const { localizedUrl } = getFormattedTrailUrls(this.props.trail, this.props.context.languageRegionCode);
    const trailUrl = localizedUrl;
    let loading = null;
    let trailInfoLinks = null;
    let cancelClasses = 'link';
    let saveButtonClasses = 'btn simple';
    if (this.state.currentState == 'saving' || this.props.currentState == 'loading') {
      loading = (
        <img
          id="loading-spinner"
          src="//cdn-assets.alltrails.com/assets/shared/loading-bar.gif"
          alt={this.props.intl.formatMessage({ defaultMessage: 'Loading...' })}
        />
      );
      cancelClasses += ' hidden';
      saveButtonClasses += ' hidden';
    }

    let cancelButton;
    let saveButtonLabel = <FormattedMessage defaultMessage="Save" />;
    let saveNoApprovalButton = null;
    let makePendingButton = null;
    let addButton = null;
    if (this.state.isPendingTrail) {
      if (this.props.rapidRoute && this.props.trail.id) {
        cancelButton = (
          <a id="cancel-button" href="" className={cancelClasses} onClick={this.handleRejectTrailClick}>
            <FormattedMessage defaultMessage="Reject" />
          </a>
        );
        saveButtonLabel = <FormattedMessage defaultMessage="Approve" />;
        saveNoApprovalButton = (
          <a id="savenoapproval-button" href="" className={cancelClasses} onClick={this.handleSaveClick}>
            <FormattedMessage defaultMessage="Save only" />
          </a>
        );
      } else
        cancelButton = (
          <a id="cancel-button" href={LanguageSupportUtil.wrapUrlSafe('/explore', this.props.context.languageRegionCode)} className={cancelClasses}>
            <FormattedMessage defaultMessage="Cancel" />
          </a>
        );
      if (this.props.rapidRoute && this.props.adminUser)
        addButton = (
          <a id="add-button" className={cancelClasses} onClick={this.props.handleAddTrailClick}>
            <FormattedMessage defaultMessage="Add trail" />
          </a>
        );
    } else if (this.props.rapidRoute) {
      addButton = (
        <a id="add-button" className={cancelClasses} onClick={this.props.handleAddTrailClick}>
          <FormattedMessage defaultMessage="Add trail" />
        </a>
      );
      cancelButton = (
        <a id="cancel-button" href={trailUrl} className={cancelClasses}>
          <FormattedMessage defaultMessage="Cancel" />
        </a>
      );
      makePendingButton = (
        <a id="makepending-button" href="" className={cancelClasses} onClick={this.handleSaveClick}>
          <FormattedMessage defaultMessage="Make pending" />
        </a>
      );
    } else {
      cancelButton = (
        <a id="cancel-button" href={trailUrl} className={cancelClasses}>
          <FormattedMessage defaultMessage="Cancel" />
        </a>
      );
    }

    if (this.props.rapidRoute) {
      const googleLink = (
        <li>
          <a className="link" target="_blank" href={`https://www.google.com/webhp?#q=${encodeURIComponent(this.props.trail.name)}`}>
            Google
          </a>
        </li>
      );
      let parkLink = null;
      let parkMapLink = null;
      if (this.props.trail.area) {
        parkLink = (
          <li>
            <a className="link" target="_blank" href={`/parks/${this.props.trail.area.slug}`}>
              <FormattedMessage defaultMessage="Park" />
            </a>
          </li>
        );
        if (this.props.trail.area.map_url)
          parkMapLink = (
            <li>
              <a className="link" target="_blank" href={this.props.trail.area.map_url}>
                <FormattedMessage defaultMessage="Map" />
              </a>
            </li>
          );
      }

      trailInfoLinks = (
        <span className="contribute-trail-links">
          <ul>
            {googleLink}
            {parkLink}
            {parkMapLink}
          </ul>
        </span>
      );
    }

    let lastEditedTime = null;
    if (this.props.trail.lastEditedTimestamp) {
      // only humanize if diff is less than a day
      const parsedTime = new Date(this.props.trail.lastEditedTimestamp);
      const now = new Date();
      let time = null;
      if (now - parsedTime > 86400000) {
        time = parsedTime.toDateString();
      } else {
        time = humanized_time_span(this.props.trail.lastEditedTimestamp);
      }
      lastEditedTime = (
        <div>
          <FormattedMessage defaultMessage="Last edited: {time}" values={{ time }} />
        </div>
      );
    }

    let photosLink = null;
    const { trailCounts, id, slug } = this.props.trail;
    if (trailCounts) {
      const photosUrl = this.props.context.adminUser ? `/contribute/admin/photos?trail_id=${id}` : `/trail/${slug}/photos`;
      photosLink = (
        <a href={photosUrl} target="_blank" rel="noreferrer">
          <FormattedMessage defaultMessage="Photos ({count})" values={{ count: trailCounts.photoCount }} />
        </a>
      );
    }

    let editItemsContainerClasses = 'edit-items-container';
    let titleDiv;
    let trailPhoto = <img src={photoUrl} height="80" width="80" />;

    if (this.state.isPendingTrail) {
      if (this.props.trail.id) {
        if (this.props.trail.slug) {
          titleDiv = (
            <div id="contribute-title" className="xlate-none">
              {trailPhoto}
              <div id="trail-contribute-title-text">
                <span title={this.props.trail.name} className="contribute-trail-name">
                  <FormattedMessage defaultMessage="Pending:" />{' '}
                  <a className="link" target="_blank" href={trailUrl}>
                    {this.props.trail.name}
                  </a>
                </span>
                <br />
                <span className="contribute-trail-location">
                  <ul>{this.renderLocation(this.props.trail.location)}</ul>
                  {lastEditedTime}
                  {trailInfoLinks}
                </span>
              </div>
            </div>
          );
        } else {
          editItemsContainerClasses += ' with-small-title';
          titleDiv = (
            <div id="contribute-title" className="small-title xlate-none">
              <div id="trail-contribute-title-text">
                <span className="contribute-trail-name">
                  <FormattedMessage defaultMessage="Pending:" /> {this.props.trail.name}
                </span>
                <br />
              </div>
            </div>
          );
        }
      } else {
        editItemsContainerClasses += ' with-no-title';
        titleDiv = null;
      }
    } else {
      titleDiv = (
        <div id="contribute-title" className="xlate-none">
          {trailPhoto}
          <div id="trail-contribute-title-text">
            <span title={this.props.trail.name} className="contribute-trail-name">
              <a className="link" target="_blank" href={trailUrl}>
                {this.props.trail.name}
              </a>
            </span>
            <br />
            <span className="contribute-trail-location">
              <ul>{this.renderLocation(this.props.trail.location)}</ul>
              {lastEditedTime}
              {photosLink}
              {trailInfoLinks}
            </span>
          </div>
        </div>
      );
    }

    return (
      <div id="edit-trail-contribute-box">
        {titleDiv}
        <div className={editItemsContainerClasses}>
          <TrailDetailsBox
            adminUser={this.props.adminUser}
            allowNameEditing={this.props.allowNameEditing}
            currentCity={this.props.currentCity}
            displayMetric={this.props.displayMetric}
            isPendingTrail={this.state.isPendingTrail}
            languageRegionCode={this.props.languageRegionCode}
            mapCenter={this.props.mapCenter}
            messagingChannel={this.props.messagingChannel}
            rapidRoute={this.props.rapidRoute}
            ref="detailsEdits"
            routeInfo={this.props.routeInfo}
            trail={this.props.trail}
            handleMapChange={this.props.handleMapChange}
            useMapAsRoute={this.props.useMapAsRoute}
            context={this.props.context}
          />
        </div>
        <div id="contribute-action-bar" className="xlate-none">
          <a
            href={`${window.base_support_url}/articles/360018930672-How-do-I-update-or-change-information-about-a-trail-`}
            target="_blank"
            className="editor-help"
          >
            <FormattedMessage defaultMessage="Help" />
          </a>
          <span className="buttons">
            {loading}
            {addButton}
            {cancelButton}
            {saveNoApprovalButton}
            {makePendingButton}
            <a data-testid="save-button" id="save-button" href="#" className={saveButtonClasses} onClick={this.handleSaveClick}>
              {saveButtonLabel}
            </a>
          </span>
        </div>
      </div>
    );
  }
});

const EditTrailBoxIntlProvider = forwardRef((props, ref) => {
  const intl = useIntl();
  return <BaseEditTrailBox {...props} intl={intl} ref={ref} />;
});

const EditTrailBox = forwardRef((props, ref) => {
  return (
    <CustomProvider>
      <EditTrailBoxIntlProvider {...props} ref={ref} />
    </CustomProvider>
  );
});

export { EditTrailBox };
